export function subscribeToMediaQuery(query, callback) {
    const mediaQueryList = window.matchMedia(query);
    mediaQueryList.addEventListener('change', callback);
    return () => {
        mediaQueryList.removeEventListener('change', callback);
    };
}
export function checkMediaQuery(query) {
    return window.matchMedia(query).matches;
}
//# sourceMappingURL=mediaQuery.js.map